import axios from 'axios';

import { IMerchantDeposit } from '@/shared/model/merchant-deposit.model';

const baseApiUrl = 'api/merchant-deposits';

export default class MerchantDepositService {
  public find(id: number): Promise<IMerchantDeposit> {
    return new Promise<IMerchantDeposit>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMerchantDeposit): Promise<IMerchantDeposit> {
    return new Promise<IMerchantDeposit>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMerchantDeposit): Promise<IMerchantDeposit> {
    return new Promise<IMerchantDeposit>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
